import request from "@/untils/request.js"

export const getExpenseCategoryPage = (params) => {
    return request.get("/outpatient/costtype/page", {params})
}

export const addExpenseCategory = (data) => {
    return request.post("/outpatient/costtype", data)
}

export const editExpenseCategory = (data) => {
    return request.put("/outpatient/costtype", data)
}

//费用类别-列表
export const getExpenseCategoryList = (params) => {
    return request.get("/outpatient/costtype/list", {params})
}